import React from 'react';
import styled from 'styled-components';
import { toast, ToastContainer } from 'react-toastify';

import Header from 'components/Header';
import { theme } from 'theme';

interface Props {
  children: React.ReactNode;
  header?: React.ReactElement | React.FunctionComponent;
}

const SLayoutContainer = styled.div`
  height: 100vh;
`;

const SLayoutMain = styled.div`
  height: calc(100% - ${theme.header.height});
  overflow-y: auto;
`;

const Layout = ({ header = <Header />, children }: Props) => (
  <SLayoutContainer>
    {header}
    <SLayoutMain>
      <ToastContainer
        hideProgressBar
        newestOnTop
        autoClose={10000}
        closeButton={false}
        draggable={false}
        position={toast.POSITION.TOP_RIGHT}
      />
      {children}
    </SLayoutMain>
  </SLayoutContainer>
);

export default Layout;
